import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bemGenerator } from '@prisjakt/ui-base';
import Tag from '@prisjakt/ui-tag';
import { AppContext } from '@prisjakt/ui-app-context';
import { filterChangeAction } from '../../../../actions/filter';

import './index.scss';

const styles = bemGenerator('selected-filters', []);

class SelectedFilters extends React.PureComponent {
  constructor(props) {
    super(props);
    this.renderTag = this.renderTag.bind(this);
  }

  static isDoubleSlider(filter) {
    return (
      filter.value &&
      filter.filterType === 'slider' &&
      (filter.value.from !== null || filter.value.to !== null) &&
      (typeof filter.value.from === 'object' ||
        typeof filter.value.to === 'object')
    );
  }

  renderTag(filter) {
    const { t } = this.context;
    const filterType = SelectedFilters.isDoubleSlider(filter)
      ? 'double-slider'
      : filter.filterType;

    let value = null;
    switch (filterType) {
      case 'slider': {
        value = filter.value
          ? `${filter.value.from} - ${filter.value.to}`
          : null;
        break;
      }
      case 'double-slider': {
        const { from, to } = filter.value;
        const fromRange = from ? `${from.from} - ${from.to}` : '';
        const toRange = to ? `${to.from} - ${to.to}` : '';
        const separator = fromRange && toRange ? '/' : '';

        value = `${fromRange} ${separator} ${toRange}`;
        break;
      }
      case 'boolean':
        value = filter.value
          ? t('filter', 'properties.select-true')
          : t('filter', 'properties.select-false');
        break;
      case 'list':
        value = filter.name;
        break;
      case 'string':
        value = filter.value;
        break;
      default:
      // do nothing;
    }

    return value ? (
      <Tag
        groupName={filter.section && filter.section.name}
        value={value}
        onClick={() => this.onChange(filter)}
      />
    ) : null;
  }

  onChange(filter) {
    const categoryId = this.props.categoryId;

    let action;
    switch (filter.filterType) {
      case 'list':
        action = { ...filter, checked: false };
        break;
      default: {
        const { [filter.key]: remove, ...filtersToKeep } = this.props.query;
        action = filtersToKeep;
      }
    }

    this.props.filterChangeAction(categoryId, action);
  }

  render() {
    const { t } = this.context;
    const { selected, className } = this.props;

    const filters = Object.keys(selected)
      .filter(key => selected[key])
      .map(key => ({
        key,
        ...selected[key],
      }));

    return (
      <div className={`${styles.block} ${className}`}>
        {filters.map(this.renderTag)}

        {filters.length > 1 && (
          <Tag
            type="clear"
            value={t('filter', 'button.clear-filter')}
            onClick={() =>
              this.props.filterChangeAction(this.props.categoryId, {})
            }
          />
        )}
      </div>
    );
  }
}

const { shape, arrayOf, string, func, object } = PropTypes;

SelectedFilters.propTypes = {
  categoryId: string.isRequired,
  selected: arrayOf(
    shape({
      id: string,
      name: string,
      filterType: string,
      section: shape({
        name: string,
        unit: string,
      }),
    })
  ).isRequired,
  query: object.isRequired, // eslint-disable-line react/forbid-prop-types
  filterChangeAction: func.isRequired,
  className: string,
};

SelectedFilters.defaultProps = {
  className: '',
};

SelectedFilters.contextType = AppContext;

export default connect(
  state => ({
    selected: state.areas.category.filter.selected,
    query: state.areas.category.filter.query,
  }),
  { filterChangeAction }
)(SelectedFilters);
